import { useState } from 'react'

const Input = (props) => {
  const [error, setError] = useState(null);
  return (
    <div style={{width: '100%', display: 'flex', flexDirection: 'column', gap: 8}}>
      <input {...props} onChange={(e) => setError(() => e.target.validationMessage)} />
      {error && <span style={{ color: '#FF6363', fontSize: '16px'}}>{error}</span>}
    </div>
  )
}

export default Input